import { render, staticRenderFns } from "./Gaceta.vue?vue&type=template&id=9b935880&"
import script from "./Gaceta.vue?vue&type=script&lang=js&"
export * from "./Gaceta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports